import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from './Context/UserContext';
import { Table, Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import "../styles/UpdateData.css";
import { Link } from "react-router-dom";
import profileImg from "../assets/logo.png";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "./DashboardLayout";

const UpdateData = () => {
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { user } = useUser();
    const [showCard, setShowCard] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [approverId, setApproverId] = useState(null);
    const [invoicesList, setInvoicesList] = useState([]);
    const [vendorsList, setVendorsList] = useState([]);
    const validInvoicesList = invoicesList.filter(
        (inv) => inv.invoiceNo && inv.invoiceNo.trim() !== ""
    );

    const [selectedInvoiceId, setSelectedInvoiceId] = useState("");
    const [selectedVendorId, setSelectedVendorId] = useState("");
    const [selectedDeptVendorId, setSelectedDeptVendorId] = useState("");
    const [vendorDetails, setVendorDetails] = useState(null);
    const [invoiceDetails, setInvoiceDetails] = useState(null);
    const [loadingInvoiceDetails, setLoadingInvoiceDetails] = useState(false);
    const [rows, setRows] = useState([]);
    const [loadingVendorDetails, setLoadingVendorDetails] = useState(false);
    const [vendorFiles, setVendorFiles] = useState([]);
    const openFilePreview = (docName, title) => {
        const file = getVendorFile(docName);
        if (!file) return;
        setPreviewFileUrl(`/api/vendor/files/${file.fileId}?mode=view`);
        setPreviewFileTitle(title);
        setPreviewFileName(file.fileName || "");
        setShowFilePreview(true);
    };
    const [showFilePreview, setShowFilePreview] = useState(false);
    const [previewFileUrl, setPreviewFileUrl] = useState("");
    const [previewFileTitle, setPreviewFileTitle] = useState("");
    const [previewFileName, setPreviewFileName] = useState("");
    const [agreementList, setAgreementList] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [fileInputKey, setFileInputKey] = useState(0);

    useEffect(() => {
        const fetchInvoicesList = async () => {
            try {
                const response = await axios.get("/api/UpdateData/GetInvoicesList");
                setInvoicesList(response.data);
            } catch (error) {
                console.error("Error fetching approved status list:", error);
            }
        };
        fetchInvoicesList();
    }, []);

    useEffect(() => {
        const fetchVendorsList = async () => {
            try {
                const response = await axios.get("/api/UpdateData/GetVendorsList");
                setVendorsList(response.data);
            } catch (error) {
                console.error("Error fetching approved status list:", error);
            }
        };
        fetchVendorsList();
    }, []);

    useEffect(() => {
        if (!selectedVendorId) {
            setVendorDetails(null);
            setVendorFiles([]);
            return;
        }
        const fetchVendorDetails = async () => {
            setLoadingVendorDetails(true);
            try {
                const { data } = await axios.get(`/api/vendordetails/vendor-details/${selectedVendorId}`);
                setVendorDetails(data);

                const { data: filesData } = await axios.get(`/api/vendor/files/vendor/${selectedVendorId}`);
                setVendorFiles(filesData || []);
            } catch (error) {
                console.error("Error fetching vendor details:", error);
                setVendorDetails(null);
                setVendorFiles([]);
            } finally {
                setLoadingVendorDetails(false);
            }
        };
        fetchVendorDetails();
    }, [selectedVendorId]);

    useEffect(() => {
        if (!selectedInvoiceId) {
            setInvoiceDetails(null);
            return;
        }
        const fetchInvoiceDetails = async () => {
            setLoadingInvoiceDetails(true);
            try {
                const { data } = await axios.get(`/api/invoices/details/${selectedInvoiceId}`);
                setInvoiceDetails(data);

                const uid = data.userId ?? data.USERID ?? data.userID;
                if (uid) {
                    const { data: agreements } = await axios.get(`/api/vendoragreement/byuser/${uid}`);
                    setAgreementList(agreements || []);
                } else {
                    setAgreementList([]);
                }
            } catch (error) {
                console.error("Error fetching invoice details:", error);
                setInvoiceDetails(null);
                setAgreementList([]);
            } finally {
                setLoadingInvoiceDetails(false);
            }
        };
        fetchInvoiceDetails();
    }, [selectedInvoiceId, refreshKey]);
    useEffect(() => {
        if (!selectedInvoiceId) {
            setRows([]);
            return;
        }
        axios.get(`/api/invoices/grnitems/${selectedInvoiceId}`)
            .then(res => {
                const items = res.data;
                if (Array.isArray(items) && items.length > 0) {
                    setRows(items.map((item, i) => ({
                        SlNo: i + 1,
                        Description: item.description || item.Description || "",
                        invoiceValue: item.invoiceValue || item.InvoiceValue || 0,
                        cgst: item.cgst || item.CGST || 0,
                        sgst: item.sgst || item.SGST || 0,
                        igst: item.igst || item.IGST || 0,
                        totalValue: String(item.totalValue || item.TotalValue || "0.00"),
                        remark: item.remark || item.Remark || "",
                        qty: item.qty || 0,
                        rcvQty: item.rcvQty || 0,
                    })));
                } else {
                    setRows([{ SlNo: 1, Description: "", invoiceValue: 0, cgst: 0, sgst: 0, igst: 0, totalValue: "0.00", remark: "" }]);
                }
            })
            .catch(err => {
                console.error("Error fetching GRN items:", err);
                setRows([{ SlNo: 1, Description: "", invoiceValue: 0, cgst: 0, sgst: 0, igst: 0, totalValue: "0.00", remark: "" }]);
            });
    }, [selectedInvoiceId, refreshKey]);

    useEffect(() => {
        const fetchApproverId = async () => {
            try {
                const res = await axios.get("/api/approvalstatus/get-approver-id");
                const id = res.data.EMPID || res.data.empid;
                setApproverId(id);
            } catch (error) {
                console.error("Failed to fetch approver ID:", error);
            }
        };
        fetchApproverId();
    }, []);

    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);
    const handleSaveGrnItems = async () => {
        if (!selectedInvoiceId) {
            alert("Please select an invoice first.");
            return;
        }
        const grnItems = rows.map(item => ({
            Description: item.Description,
            InvoiceValue: parseFloat(item.invoiceValue) || 0,
            CGST: parseFloat(item.cgst) || 0,
            SGST: parseFloat(item.sgst) || 0,
            IGST: parseFloat(item.igst) || 0,
            TotalValue: parseFloat(item.totalValue) || 0,
            remark: item.remark || "",
            Qty: item.qty || 0,
            RcvQty: item.rcvQty || 0,
        }));
        try {
            await axios.put(`/api/invoices/grnitems/update?grnId=${selectedInvoiceId}`, grnItems, {
                headers: { "Content-Type": "application/json" }
            });
            alert("Invoice items updated successfully");
        } catch (error) {
            console.error("Error updating invoice items:", error);
            alert("Failed to update invoice items");
        }
    };

    const getVendorFile = (docName) => vendorFiles.find(f => f.docName === docName);
    const handleRowChange = (e, index) => {
        const { name, value } = e.target;
        setRows(prevRows => {
            const updated = prevRows.map(r => ({ ...r }));
            if (["invoiceValue", "cgst", "sgst", "igst"].includes(name)) {
                updated[index][name] = parseFloat(String(value).replace(/,/g, "")) || 0;
            } else {
                updated[index][name] = value;
            }
            const iv = parseFloat(updated[index].invoiceValue) || 0;
            const cg = parseFloat(updated[index].cgst) || 0;
            const sg = parseFloat(updated[index].sgst) || 0;
            const ig = parseFloat(updated[index].igst) || 0;
            updated[index].totalValue = (iv + iv * (cg + sg + ig) / 100).toFixed(2);
            return updated;
        });
    };

    const addRow = () => {
        setRows(prev => [...prev, {
            SlNo: prev.length + 1, Description: "", invoiceValue: 0, cgst: 0, sgst: 0, igst: 0, totalValue: "0.00", remark: ""
        }]);
    };

    const removeRow = (index) =>
        setRows(prev => prev.filter((_, i) => i !== index).map((r, i) => ({ ...r, SlNo: i + 1 })));

    const [form, setForm] = useState({
        invoiceType: "",
        comments: "",
        vendorCode: "",
        vendorComments: "",
        supplierType: "",
        departmentHead: "",
        verifier: "",
        deptComments: ""
    });

    const [files, setFiles] = useState({
        invoiceCopy: null,
        poAgreement: null,
        timesheet: null,
        poAdmin: null,
        prAdmin: null,
        panCopy: null,
        chequeCopy: null,
        gstCopy: null,
        msmeCopy: null
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setFiles({ ...files, [e.target.name]: e.target.files[0] || null });
    };

    // ---------------- SUBMIT HANDLERS ----------------

    const handleSubmitInvoice = async () => {
        if (!selectedInvoiceId) { alert("Please select an invoice first."); return; }
        const userId = user?.empId || approverId;
        if (!userId) { alert("Could not determine user ID. Please refresh and try again."); return; }

        let step = "invoice details";
        try {
            // 1. Invoice details
            if (invoiceDetails) {
                const updateForm = new FormData();
                updateForm.append("invoiceType", invoiceDetails.invoiceType || "");
                updateForm.append("InvoiceDate", invoiceDetails.invoiceDate || "");
                updateForm.append("InvoiceNo", invoiceDetails.invoiceNo || "");
                updateForm.append("pono", invoiceDetails.pono || "");
                updateForm.append("PO_Date", invoiceDetails.po_Date || "");
                updateForm.append("DeliveryChallanNumber", invoiceDetails.deliveryChallanNumber || "");
                updateForm.append("supplierType", invoiceDetails.invoiceSupplierType || "");
                updateForm.append("POType",
                    invoiceDetails.poType === "PO" ? 1 :
                        invoiceDetails.poType === "Agreement" ? 2 :
                            invoiceDetails.poType === "Approval" ? 3 : ""
                );
                updateForm.append("AgreementId", invoiceDetails.poType === "Agreement" ? (invoiceDetails.agreementId || "") : "");
                await axios.put(`/api/invoices/vendorinvoicedetails/${selectedInvoiceId}`, updateForm, {
                    headers: { "Content-Type": "multipart/form-data" }
                });
            }

            // 2. Invoice items (blank rows skipped)
            step = "invoice items";
            const grnItems = rows
                .filter(r => (r.Description && r.Description.trim() !== "") || parseFloat(r.invoiceValue) > 0)
                .map(item => ({
                    Description: item.Description,
                    InvoiceValue: parseFloat(item.invoiceValue) || 0,
                    CGST: parseFloat(item.cgst) || 0,
                    SGST: parseFloat(item.sgst) || 0,
                    IGST: parseFloat(item.igst) || 0,
                    TotalValue: parseFloat(item.totalValue) || 0,
                    remark: item.remark || "",
                    Qty: item.qty || 0,
                    RcvQty: item.rcvQty || 0,
                }));
            if (grnItems.length > 0) {
                await axios.put(`/api/invoices/grnitems/update?grnId=${selectedInvoiceId}`, grnItems, {
                    headers: { "Content-Type": "application/json" }
                });
            }

            // 3. Files + invoice type
            step = "files";
            const hasFile = files.invoiceCopy || files.poAgreement || files.timesheet || files.poAdmin || files.prAdmin;
            if (hasFile || form.invoiceType) {
                const fd = new FormData();
                fd.append("InvoiceId", selectedInvoiceId);
                fd.append("UserId", userId);
                fd.append("Comments", form.comments || "");
                if (form.invoiceType) fd.append("InvoiceType", form.invoiceType);
                if (files.invoiceCopy) fd.append("InvoiceCopy", files.invoiceCopy);
                if (files.poAgreement) fd.append("POAgreement", files.poAgreement);
                if (files.timesheet) fd.append("Timesheet", files.timesheet);
                if (files.poAdmin) fd.append("POAdmin", files.poAdmin);
                if (files.prAdmin) fd.append("PRAdmin", files.prAdmin);
                await axios.post("/api/UpdateData/update-invoice", fd, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            }

            alert("Invoice submitted and updated successfully");
            setFiles(f => ({ ...f, invoiceCopy: null, poAgreement: null, timesheet: null, poAdmin: null, prAdmin: null }));
            setFileInputKey(k => k + 1);
            setRefreshKey(k => k + 1);
        } catch (error) {
            console.error(`Error saving ${step}:`, error);
            const msg = typeof error.response?.data === "string" ? error.response.data : "";
            alert(`Failed while saving ${step}. ${msg}`);
        }
    };
    const handleSubmitVendor = async () => {
        console.log("user:", user, "approverId:", approverId);

        const userId = user?.empId || approverId;

        if (!userId) {
            alert("Could not determine approver ID. Please refresh and try again.");
            console.error("UserId missing — user:", user, "approverId:", approverId);
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append("VendorId", selectedVendorId);
        formDataToSend.append("VendorCode", form.vendorCode);
        formDataToSend.append("Comments", form.vendorComments);
        formDataToSend.append("UserId", userId);

        if (files.panCopy) formDataToSend.append("PanCopy", files.panCopy);
        if (files.chequeCopy) formDataToSend.append("ChequeCopy", files.chequeCopy);
        if (files.gstCopy) formDataToSend.append("GstCopy", files.gstCopy);
        if (files.msmeCopy) formDataToSend.append("MsmeCopy", files.msmeCopy);

        try {
            await axios.post("/api/UpdateData/update-vendor", formDataToSend, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            alert("Vendor updated successfully");

            const { data } = await axios.get(`/api/vendors/${selectedVendorId}`);
            setVendorDetails(data);
        } catch (error) {
            console.error("Error updating vendor:", error);
            alert("Failed to update vendor");
        }
    };

    const handleVendorDetailsChange = (e) => {
        setVendorDetails({ ...vendorDetails, [e.target.name]: e.target.value });
    };

    const handleSaveVendorDetails = async () => {
        const userId = user?.empId || approverId;

        if (!selectedVendorId) {
            alert("Please select a vendor first.");
            return;
        }
        if (!userId) {
            alert("Could not determine approver ID. Please refresh and try again.");
            return;
        }

        try {
            await axios.post("/api/UpdateData/update-vendor-details", {
                vendorId: selectedVendorId,
                natureOfSupply: vendorDetails.natureOfSupply,
                businessRegNo: vendorDetails.businessRegNo,
                legalName: vendorDetails.legalName,
                shortName: vendorDetails.shortName,
                address1: vendorDetails.address1,
                address2: vendorDetails.address2,
                city: vendorDetails.city,
                state: vendorDetails.state,
                country: vendorDetails.country,
                postalCode: vendorDetails.postalCode != null ? String(vendorDetails.postalCode) : "",
                telephone: vendorDetails.telephone,
                email: vendorDetails.email,
                bankName: vendorDetails.bankName,
                branchName: vendorDetails.branchName,
                ifscCode: vendorDetails.ifscCode,
                accountNumber: vendorDetails.accountNumber,
                pan: vendorDetails.pan,
                beneficiaryName: vendorDetails.beneficiaryName,
                gst: vendorDetails.gst,
                msmeNo: vendorDetails.msmeNo,
                vendorCode: vendorDetails.vendorCode,
                userId: userId
            });
            alert("Vendor details updated successfully");
        } catch (error) {
            console.error("Error updating vendor details:", error);
            alert("Failed to update vendor details");
        }
    };

    const handleInvoiceDetailsChange = (e) => {
        setInvoiceDetails({ ...invoiceDetails, [e.target.name]: e.target.value });
    };

    const handleSaveInvoiceDetails = async () => {
        if (!selectedInvoiceId) {
            alert("Please select an invoice first.");
            return;
        }
        const updateForm = new FormData();
        updateForm.append("invoiceType", invoiceDetails.invoiceType || "");
        updateForm.append("InvoiceDate", invoiceDetails.invoiceDate || "");
        updateForm.append("InvoiceNo", invoiceDetails.invoiceNo || "");
        updateForm.append("pono", invoiceDetails.pono || "");
        updateForm.append("PO_Date", invoiceDetails.po_Date || "");
        updateForm.append("DeliveryChallanNumber", invoiceDetails.deliveryChallanNumber || "");
        updateForm.append("supplierType", invoiceDetails.invoiceSupplierType || "");
        updateForm.append("POType",
            invoiceDetails.poType === "PO" ? 1 :
                invoiceDetails.poType === "Agreement" ? 2 :
                    invoiceDetails.poType === "Approval" ? 3 : ""
        );
        updateForm.append("AgreementId", invoiceDetails.poType === "Agreement" ? (invoiceDetails.agreementId || "") : "");

        try {
            await axios.put(`/api/invoices/vendorinvoicedetails/${selectedInvoiceId}`, updateForm, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            alert("Invoice details updated successfully");
        } catch (error) {
            console.error("Error updating invoice details:", error);
            alert("Failed to update invoice details");
        }
    };

    const openInvoiceFilePreview = (type, title, fileName) => {
        if (!fileName) return;
        setPreviewFileUrl(`/api/UpdateData/invoice-file/${selectedInvoiceId}/${type}?mode=view&t=${Date.now()}`);
        setPreviewFileTitle(title);
        setPreviewFileName(fileName || "");
        setShowFilePreview(true);
    };

    const handleSubmitDept = () => {
        
        alert("Submitted Department Change");
        console.log({ selectedDeptVendorId, form });
    };

    return (
        <DashboardLayout>
            <div className="wrapper">
                <h2 className="title">Update Data</h2>

                {/* PANEL 1 */}
                <div className="card" key="invoice-details-top">
                    <h3 className="section-title">Invoice Details</h3>
                    <div className="grid-3">
                        <div className="field">
                            <label>Invoice Number</label>
                            <select
                                value={selectedInvoiceId}
                                onChange={(e) => setSelectedInvoiceId(e.target.value)}
                            >
                                <option value="">Select</option>
                                {invoicesList.map((inv, idx) => (
                                    <option key={`${inv.id}-${idx}`} value={inv.id}>
                                        {inv.invoiceNo}
                                    </option>
                                ))}
                            </select>
                            
                        </div>
                    </div>

                    {loadingInvoiceDetails && (
                        <p>Loading invoice details...</p>
                    )}

                    {invoiceDetails && !loadingInvoiceDetails && (
                        <div className="card" style={{ background: "#f9f9f9", marginTop: "10px" }}>
                            <h4 className="section-title" style={{ fontSize: "14px" }}>
                                Existing Invoice Details
                            </h4>
                            <div className="grid-3">
                                <div className="field"><label>Invoice No</label><input name="invoiceNo" value={invoiceDetails.invoiceNo || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>Invoice Type</label><input name="invoiceType" value={invoiceDetails.invoiceType || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>PO Number</label><input name="pono" value={invoiceDetails.pono || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>Agreement No</label><input name="agreementNo" value={invoiceDetails.agreementNo || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>Start Date</label><input type="date" name="startDate" value={invoiceDetails.startDate || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>End Date</label><input type="date" name="endDate" value={invoiceDetails.endDate || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>PO Reference Number</label><input name="poReferenceNumber" value={invoiceDetails.poReferenceNumber || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>Delivery Challan Number</label><input name="deliveryChallanNumber" value={invoiceDetails.deliveryChallanNumber || ""} onChange={handleInvoiceDetailsChange} /></div>
                             
                                <div className="field"><label>LOB</label><input name="lob" value={invoiceDetails.lob || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>Probable Name</label><input name="probname" value={invoiceDetails.probname || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>MSPE</label><input name="mspe" value={invoiceDetails.mspe || ""} onChange={handleInvoiceDetailsChange} /></div>
                               
                            </div>
                            <div className="invoice-items-wrap" style={{ marginTop: "16px" }}>
                                <table className="invoice-items-table" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>Sr. No</th>
                                            <th>Description</th>
                                            <th>Invoice Value</th>
                                            <th>CGST (%)</th>
                                            <th>SGST (%)</th>
                                            <th>IGST (%)</th>
                                            <th>Total Value</th>
                                            <th>Remarks</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.SlNo}</td>
                                                <td><input name="Description" value={row.Description} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="invoiceValue" value={row.invoiceValue || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="cgst" value={row.cgst || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="sgst" value={row.sgst || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="igst" value={row.igst || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="totalValue" value={row.totalValue || ""} readOnly /></td>
                                                <td><input name="remark" value={row.remark || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td>
                                                    <button type="button" onClick={addRow}>+ Add</button>
                                                    {rows.length > 1 && <button type="button" onClick={() => removeRow(index)}>Delete</button>}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="btn-wrapper">
                                    <button className="btn" onClick={handleSaveGrnItems}>Save Invoice Items</button>
                                </div>
                            </div>
                            <div className="btn-wrapper">
                                <button className="btn" onClick={handleSaveInvoiceDetails}>Save Invoice Details</button>
                            </div>
                        </div>
                    )}

                    <div className="grid-3" style={{ marginTop: "16px" }}>
                        <div className="field">
                            <label>Invoice Copy</label>
                            <input key={fileInputKey} type="file" name="invoiceCopy" onChange={handleFileChange} />
                            {invoiceDetails?.fileName && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openInvoiceFilePreview("invoice", "Invoice Copy Preview", invoiceDetails.fileName)}>
                                    View existing file
                                </Button>
                            )}
                            
                        </div>
                        <div className="field">
                            <label>PO/Agreement</label>
                            <input type="file" name="poAgreement" onChange={handleFileChange} />
                            {invoiceDetails?.fileNameAgreement && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openInvoiceFilePreview("agreement", "PO/Agreement Preview", invoiceDetails.fileNameAgreement)}>
                                    View existing file
                                </Button>
                            )}
                        </div>
                        <div className="field">
                            <label>Timesheet</label>
                            <input type="file" name="timesheet" onChange={handleFileChange} />
                            {invoiceDetails?.fileNameTimeSheet && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openInvoiceFilePreview("timesheet", "Timesheet Preview", invoiceDetails.fileNameTimeSheet)}>
                                    View existing file
                                </Button>
                            )}
                        </div>
                        <div className="field">
                            <label>PO (Admin)</label>
                            <input type="file" name="poAdmin" onChange={handleFileChange} />
                        </div>
                        <div className="field">
                            <label>PR (Admin)</label>
                            <input type="file" name="prAdmin" onChange={handleFileChange} />
                        </div>
                        <div className="field">
                            <label>Invoice Type</label>
                            <select name="invoiceType" value={form.invoiceType} onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="Tax Invoice">Tax Invoice</option>
                                <option value="Debit Note">Debit Note</option>
                            </select>
                        </div>
                        <div className="field full">
                            <label>Comments</label>
                            <textarea name="comments" value={form.comments} onChange={handleChange}></textarea>
                           
                        </div>
                    </div>
                    <div className="btn-wrapper">
                        <button className="btn" onClick={handleSubmitInvoice}>Submit Invoice</button>
                    </div>
                </div>

                {/* PANEL 2 */}
                <div className="card">
                    <h3 className="section-title">Vendor Details</h3>
                    <div className="grid-3">
                        <div className="field">
                            <label>Vendor Name</label>
                            <select
                                value={selectedVendorId}
                                onChange={(e) => setSelectedVendorId(e.target.value)}
                            >
                                <option value="">Select</option>
                                {vendorsList.map((v) => (
                                    <option key={v.id} value={v.id}>
                                        {v.nameofcompany}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {loadingVendorDetails && (
                            <div className="field full">
                                <p>Loading vendor details...</p>
                            </div>
                        )}

                        {vendorDetails && !loadingVendorDetails && (
                            <div className="field full">
                                <div className="card" style={{ background: "#f9f9f9" }}>
                                    <h4 className="section-title" style={{ fontSize: "14px" }}>
                                        Registered Vendor Details
                                    </h4>
                                    <div className="grid-3">
                                        <div className="field"><label>Nature of Supply</label><input name="natureOfSupply" value={vendorDetails.natureOfSupply || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Business Reg No.</label><input name="businessRegNo" value={vendorDetails.businessRegNo || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Legal Name</label><input name="legalName" value={vendorDetails.legalName || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Short Name</label><input name="shortName" value={vendorDetails.shortName || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Address Line 1</label><input name="address1" value={vendorDetails.address1 || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Address Line 2</label><input name="address2" value={vendorDetails.address2 || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>City</label><input name="city" value={vendorDetails.city || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>State</label><input name="state" value={vendorDetails.state || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Country</label><input name="country" value={vendorDetails.country || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Zip/Postal Code</label><input name="postalCode" value={vendorDetails.postalCode || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Telephone</label><input name="telephone" value={vendorDetails.telephone || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Email</label><input name="email" value={vendorDetails.email || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Bank Name</label><input name="bankName" value={vendorDetails.bankName || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Branch Name</label><input name="branchName" value={vendorDetails.branchName || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>IFSC Code</label><input name="ifscCode" value={vendorDetails.ifscCode || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Account Number</label><input name="accountNumber" value={vendorDetails.accountNumber || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>PAN</label><input name="pan" value={vendorDetails.pan || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Beneficiary Name</label><input name="beneficiaryName" value={vendorDetails.beneficiaryName || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>GST Number</label><input name="gst" value={vendorDetails.gst || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>MSME No.</label><input name="msmeNo" value={vendorDetails.msmeNo || ""} onChange={handleVendorDetailsChange} /></div>
                                        <div className="field"><label>Vendor Code</label><input name="vendorCode" value={vendorDetails.vendorCode || ""} onChange={handleVendorDetailsChange} /></div>
                                    </div>
                                    <div className="btn-wrapper">
                                        <button className="btn" onClick={handleSaveVendorDetails}>Save Vendor Details</button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="field">
                            <label>PAN Copy</label>
                            <input type="file" name="panCopy" onChange={handleFileChange} />
                            {getVendorFile("PAN") && (
                                <Button
                                    color="link"
                                    size="sm"
                                    style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openFilePreview("PAN", "PAN Card Preview")}
                                >
                                    View existing file
                                </Button>
                            )}
                            
                        </div>
                        <div className="field">
                            <label>Cheque Copy</label>
                            <input type="file" name="chequeCopy" onChange={handleFileChange} />
                            {getVendorFile("CHEQUE") && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openFilePreview("CHEQUE", "Cancelled Cheque Preview")}>
                                    View existing file
                                </Button>
                            )}
                        </div>
                        <div className="field">
                            <label>GST Copy</label>
                            <input type="file" name="gstCopy" onChange={handleFileChange} />
                            {getVendorFile("GST") && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openFilePreview("GST", "GST Certificate Preview")}>
                                    View existing file
                                </Button>
                            )}
                            
                        </div>
                        <div className="field">
                            <label>MSME Copy</label>
                            <input type="file" name="msmeCopy" onChange={handleFileChange} />
                            {getVendorFile("MSME") && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openFilePreview("MSME", "MSME Certificate Preview")}>
                                    View existing file
                                </Button>
                            )}
                        </div>
                        <div className="field">
                            <label>Vendor Code</label>
                            <input name="vendorCode" value={form.vendorCode} onChange={handleChange} />
                           
                        </div>
                        <div className="field full">
                            <label>Comments</label>
                            <textarea name="vendorComments" value={form.vendorComments} onChange={handleChange}></textarea>
                            
                        </div>
                    </div>
                    <div className="btn-wrapper">
                        <button className="btn" onClick={handleSubmitVendor}>Update</button>
                    </div>
                </div>
                {/* PANEL 1 ,added below Vendor Details*/}
                <div className="card" key="invoice-details-bottom">
                    <h3 className="section-title">Invoice Details</h3>
                    <div className="grid-3">
                        <div className="field">
                            <label>Invoice Number</label>
                            <select
                                value={selectedInvoiceId}
                                onChange={(e) => setSelectedInvoiceId(e.target.value)}
                            >
                                <option value="">Select</option>
                                {invoicesList.map((inv, idx) => (
                                    <option key={`${inv.id}-${idx}`} value={inv.id}>
                                        {inv.invoiceNo && inv.invoiceNo.trim() !== "" ? inv.invoiceNo : `(No Invoice No) - ID ${inv.id}`}
                                    </option>
                                ))}
                            </select>

                        </div>
                    </div>

                    {loadingInvoiceDetails && (
                        <p>Loading invoice details...</p>
                    )}

                    {invoiceDetails && !loadingInvoiceDetails && (
                        <div className="card" style={{ background: "#f9f9f9", marginTop: "10px" }}>
                            <h4 className="section-title" style={{ fontSize: "14px" }}>
                                Existing Invoice Details
                            </h4>
                            <div className="grid-3">
                                <div className="field"><label>Invoice No</label><input name="invoiceNo" value={invoiceDetails.invoiceNo || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>Invoice Type</label><input name="invoiceType" value={invoiceDetails.invoiceType || ""} onChange={handleInvoiceDetailsChange} /></div>
                                <div className="field"><label>Supplier Type</label>
                                    <select name="supplierType" value={invoiceDetails.invoiceSupplierType || ""} onChange={handleInvoiceDetailsChange}>
                                        <option value="">Select</option>
                                        <option value="1">Supply of Material</option>
                                        <option value="2">Supply of Service</option>
                                        <option value="3">Both</option>
                                    </select>
                                </div>
                                <div className="field"><label>PO / Agreement</label>
                                    <select name="poType" value={invoiceDetails.poType || ""} onChange={handleInvoiceDetailsChange}>
                                        <option value="">Select</option>
                                        <option value="PO">PO</option>
                                        <option value="Agreement">Agreement</option>
                                        <option value="Approval">Approval</option>
                                    </select>
                                </div>
                                {invoiceDetails.poType === "PO" && (
                                    <>
                                        <div className="field"><label>PO Number</label><input name="pono" value={invoiceDetails.pono || ""} onChange={handleInvoiceDetailsChange} /></div>
                                        <div className="field"><label>PO Date</label><input type="date" name="po_Date" value={invoiceDetails.po_Date || ""} onChange={handleInvoiceDetailsChange} /></div>
                                    </>
                                )}
                                {invoiceDetails.poType === "Agreement" && (
                                    <div className="field"><label>Agreement Reference</label>
                                        <select name="agreementId" value={invoiceDetails.agreementId || ""} onChange={handleInvoiceDetailsChange}>
                                            <option value="">Select</option>
                                            {agreementList.map(a => (
                                                <option key={a.agreementId} value={a.agreementId}>{a.agreementDate}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                                <div className="field"><label>Delivery Challan Number</label><input name="deliveryChallanNumber" value={invoiceDetails.deliveryChallanNumber || ""} onChange={handleInvoiceDetailsChange} /></div>
                            </div>
                            <div className="invoice-items-wrap" style={{ marginTop: "16px" }}>
                                <table className="invoice-items-table" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>Sr. No</th>
                                            <th>Description</th>
                                            <th>Invoice Value</th>
                                            <th>CGST (%)</th>
                                            <th>SGST (%)</th>
                                            <th>IGST (%)</th>
                                            <th>Total Value</th>
                                            <th>Remarks</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.SlNo}</td>
                                                <td><input name="Description" value={row.Description} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="invoiceValue" value={row.invoiceValue || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="cgst" value={row.cgst || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="sgst" value={row.sgst || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="igst" value={row.igst || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td><input name="totalValue" value={row.totalValue || ""} readOnly /></td>
                                                <td><input name="remark" value={row.remark || ""} onChange={(e) => handleRowChange(e, index)} /></td>
                                                <td>
                                                    <button type="button" onClick={addRow}>+ Add</button>
                                                    {rows.length > 1 && <button type="button" onClick={() => removeRow(index)}>Delete</button>}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="btn-wrapper">
                                    <button className="btn" onClick={handleSaveGrnItems}>Save Invoice Items</button>
                                </div>
                            </div>
                            <div className="btn-wrapper">
                                <button className="btn" onClick={handleSaveInvoiceDetails}>Save Invoice Details</button>
                            </div>
                        </div>
                    )}

                    <div className="grid-3" style={{ marginTop: "16px" }}>
                        <div className="field">
                            <label>Invoice Copy</label>
                            <input type="file" name="invoiceCopy" onChange={handleFileChange} />
                            {invoiceDetails?.fileName && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openInvoiceFilePreview("invoice", "Invoice Copy Preview", invoiceDetails.fileName)}>
                                    View existing file
                                </Button>
                            )}

                        </div>
                        <div className="field">
                            <label>PO/Agreement</label>
                            <input key={fileInputKey} type="file" name="poAgreement" onChange={handleFileChange} />
                            {invoiceDetails?.fileNameAgreement && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openInvoiceFilePreview("agreement", "PO/Agreement Preview", invoiceDetails.fileNameAgreement)}>
                                    View existing file
                                </Button>
                            )}
                        </div>
                        <div className="field">
                            <label>Timesheet</label>
                            <input type="file" name="timesheet" onChange={handleFileChange} />
                            {invoiceDetails?.fileNameTimeSheet && (
                                <Button color="link" size="sm" style={{ fontSize: "12px", padding: 0 }}
                                    onClick={() => openInvoiceFilePreview("timesheet", "Timesheet Preview", invoiceDetails.fileNameTimeSheet)}>
                                    View existing file
                                </Button>
                            )}
                        </div>
                        <div className="field">
                            <label>PO (Admin)</label>
                            <input type="file" name="poAdmin" onChange={handleFileChange} />
                        </div>
                        <div className="field">
                            <label>PR (Admin)</label>
                            <input type="file" name="prAdmin" onChange={handleFileChange} />
                        </div>
                        <div className="field">
                            <label>Invoice Type</label>
                            <select name="invoiceType" value={form.invoiceType} onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="Tax Invoice">Tax Invoice</option>
                                <option value="Debit Note">Debit Note</option>
                            </select>
                        </div>
                        <div className="field full">
                            <label>Comments</label>
                            <textarea name="comments" value={form.comments} onChange={handleChange}></textarea>

                        </div>
                    </div>
                    <div className="btn-wrapper">
                        <button className="btn" onClick={handleSubmitInvoice}>Submit Invoice</button>
                    </div>
                </div>
                {/* PANEL 3 */}
                <div className="card">
                    <h3 className="section-title">Department Change</h3>
                    <div className="grid-3">
                        <div className="field">
                            <label>Vendor</label>
                            <select
                                value={selectedDeptVendorId}
                                onChange={(e) => setSelectedDeptVendorId(e.target.value)}
                            >
                                <option value="">Select</option>
                                {vendorsList.map((v) => (
                                    <option key={v.id} value={v.id}>
                                        {v.nameofcompany}
                                    </option>
                                ))}
                            </select>
                            
                        </div>
                        <div className="field">
                            <label>Supplier Type</label>
                            <select name="supplierType" value={form.supplierType} onChange={handleChange}>
                                <option value="">Select</option>
                                {vendorsList.map((v, idx) => (
                                    <option key={idx} value={v.suppliertype}>
                                        {v.suppliertype}
                                    </option>
                                ))}
                            </select>
                            
                        </div>
                        <div className="field">
                            <label>Department Head</label>
                            <select name="departmentHead" value={form.departmentHead} onChange={handleChange}>
                                <option value="">Select</option>
                            </select>
                            
                        </div>
                        <div className="field">
                            <label>Verifier</label>
                            <select name="verifier" value={form.verifier} onChange={handleChange}>
                                <option value="">Select</option>
                            </select>
                            
                        </div>
                        <div className="field full">
                            <label>Comments</label>
                            <textarea name="deptComments" value={form.deptComments} onChange={handleChange}></textarea>
                            
                        </div>
                    </div>
                    <div className="btn-wrapper">
                        <button className="btn danger" onClick={handleSubmitDept}>Update Dept</button>
                    </div>
                </div>
                <Modal isOpen={showFilePreview} toggle={() => setShowFilePreview(false)} size="lg" centered>
                    <ModalHeader toggle={() => setShowFilePreview(false)}>{previewFileTitle}</ModalHeader>
                    <ModalBody style={{ textAlign: "center", padding: 0 }}>
                        {previewFileName.toLowerCase().endsWith(".pdf") ? (
                            <iframe
                                src={previewFileUrl}
                                style={{ width: "100%", height: "80vh", border: "none", display: "block" }}
                                title="File Preview"
                            />
                        ) : (
                            <img
                                src={previewFileUrl}
                                style={{ maxWidth: "100%", maxHeight: "80vh", display: "block", margin: "0 auto" }}
                                alt="preview"
                            />
                        )}
                    </ModalBody>
                </Modal>
            </div>
        </DashboardLayout>
    );
};

export default UpdateData;